import { actionNameGenerator } from "../../utils/commonUtil";

const domainPrefix = "msg";
const messageActionNameGenerator = actionNameGenerator(domainPrefix);

export const fetchMessageType = messageActionNameGenerator("fetchMessage");

export const fetchAllMessageType = messageActionNameGenerator("fetchAllMessage");

export const storeAllMessageType = messageActionNameGenerator("storeAllMessage");

export const selectionChangeType = messageActionNameGenerator("selectionChange");

export const messageFullDisplayType = messageActionNameGenerator("messageFullDisplay");

export const messageFullDisplayInitialType = messageActionNameGenerator("messageFullDisplayInitial");

export const messageDataLoadingType = messageActionNameGenerator("messageDataLoading");

export const additionalAccountDetailsType = messageActionNameGenerator("additionalAccountDetails");

export const messagingDataSuccessType = messageActionNameGenerator("messagingDataSuccess");

export const messagingDataFailureType = messageActionNameGenerator("messagingDataFailure");

export const messagingAllDataLoadingType = messageActionNameGenerator("messagingAllDataLoading");

export const messagingAllDataSuccessType = messageActionNameGenerator("messagingAllDataSuccess");

export const messagingAllDataFailureType = messageActionNameGenerator("messagingAllDataFailure");
